import React, { Component } from "react"
import { Typeahead } from "react-bootstrap-typeahead";
import {Button, FormControl, FormGroup, Glyphicon, InputGroup, Well} from "react-bootstrap";
import {connect} from "react-redux";
import axios from "axios";
import getServerURL from "../../../../functions/getServerURL";
import NewDataSourceModal from "./NewDataSourceModal";


class FilterSidebar extends Component {

  state = {
    dataSourceList: [],
    dataSourceName: this.props.name || "",
    fetchingDataSourceList: false
  }

  getDataSourceList = () => {
    this.setState({ fetchingDataSourceList: true }, () => {
      axios.get(`${getServerURL()}access-request-data-sources/`, {
        headers: { "Authorization": `Bearer ${localStorage.getItem("token")}` }
      }).then(response => {
        this.setState({ dataSourceList: response.data })
      }).catch(error => {
        console.log(error, error.response)
      }).finally(() => {
        this.setState({ fetchingDataSourceList: false })
      })
    })
  }

  componentDidMount() {
    this.getDataSourceList()
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.activeTab !== this.props.activeTab) {
      this.getDataSourceList()
    }
  }

  handleEnterPress = (e) => {
    const { handleChangeFilters } = this.props
    const { dataSourceName } = this.state
    if (e.key === 'Enter') {
      handleChangeFilters("name", dataSourceName)
    }
  }

  renderFields = () => {
    const { dataSourceList, dataSourceName } = this.state
    const {
      activeTab,
      clients,
      handleChangeFilters,
      selectedClients,
      selectedDataSources,
      selectedUsers,
      fetchingRequests,
      fetchingDataSources,
      getDataSources,
      users,
    } = this.props

    if (["approved", "pending"].includes(activeTab)) {
      return (
        <React.Fragment>
          <div>
            <h5>
              Client(s)
            </h5>
            <Typeahead
              style={{ margin: "25px" }}
              disabled={ fetchingRequests || fetchingDataSources }
              clearButton
              id='SelectClientsTypeahead'
              multiple
              labelKey={ client => `${client.name} ${client.short_code}` }
              options={ clients }
              selected={ selectedClients }
              onChange={ (selectedClients) => handleChangeFilters("selectedClients", selectedClients) }
              placeholder="Client"
            />
          </div>
          <div>
            <h5>
              Data Source(s)
            </h5>
            <Typeahead
              style={{ margin: "25px" }}
              clearButton
              disabled={ fetchingRequests || fetchingDataSources }
              id='SelectDataSourcesTypeahead'
              labelKey={ dataSource => `${dataSource.name}` }
              options={ dataSourceList }
              multiple
              selected={ selectedDataSources }
              onChange={ (selectedDataSources) => handleChangeFilters("selectedDataSources", selectedDataSources) }
              placeholder="Data Source"
            />
          </div>
          <div>
            <h5>User(s)</h5>
            <Typeahead
              id="selectUsersTypeahead"
              clearButton
              multiple
              disabled={ fetchingRequests || fetchingDataSources }
              labelKey={ user => `${user.first_name} ${user.last_name}` }
              renderMenuItemChildren={this._renderMenuItemChildren}
              selected={ selectedUsers }
              options={ users.filter(userOption => userOption.department !== "Former Employee" && userOption.email.includes("genesisrg.com")) }
              placeholder="Users"
              onChange={ (selectedUsers) => handleChangeFilters("selectedUsers", selectedUsers) }
            />
          </div>
        </React.Fragment>
      )
    } else if (activeTab === "dataSources") {
      return (
        <React.Fragment>
          <div>
            <h5>
              Name
            </h5>
            <FormGroup>
              <InputGroup>
                <FormControl
                  disabled={ fetchingRequests || fetchingDataSources }
                  value={ dataSourceName }
                  onChange={ (e) => this.setState({ dataSourceName: e.target.value })}
                  onKeyDown={ this.handleEnterPress }
                  placeholder="Name"
                />
                <InputGroup.Button>
                  <Button
                    bsStyle="default"
                    onClick={ () => handleChangeFilters("name", dataSourceName) }
                  >
                    <Glyphicon glyph="search" />
                  </Button>
                </InputGroup.Button>
              </InputGroup>
            </FormGroup>
          </div>
          <div>
            <h5>
              Client(s)
            </h5>
            <Typeahead
              style={{ margin: "25px" }}
              disabled={ fetchingRequests || fetchingDataSources }
              clearButton
              id='SelectClientsTypeahead'
              multiple
              labelKey={ client => `${client.name} ${client.short_code}` }
              options={ clients }
              selected={ selectedClients }
              onChange={ (selectedClients) => handleChangeFilters("selectedClients", selectedClients) }
              placeholder="Client"
            />
          </div>
          <br/>
          <NewDataSourceModal getDataSources={ getDataSources } />
        </React.Fragment>
      )
    } else {
      return null
    }
  }

  render() {
    return (
      <Well>
        <center>
          <h3 style={{ marginTop: "0px" }}>Filters</h3>
        </center>
        { this.renderFields() }
      </Well>
    );
  }
}

const mapStateToProps = state => {
  return {
    clients: state.manageLogin.clients,
    users: state.manageLogin.users
  }
}

export default connect(mapStateToProps)(FilterSidebar)


// WEBPACK FOOTER //
// ./src/routes/data-access-request/DataAccessRequestManager/components/FilterSidebar.js